export default __webpack_public_path__ + "static/04.symbol_diagram-6c708afea9dd61c86f3075972912cf0c.svg";